import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Amplify } from 'aws-amplify';
import { signIn, signOut, signUp, confirmSignUp, fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: (import.meta as any).env?.VITE_COGNITO_USER_POOL_ID || (window as any).__env?.COGNITO_USER_POOL_ID,
      userPoolClientId: (import.meta as any).env?.VITE_COGNITO_USER_POOL_CLIENT_ID || (window as any).__env?.COGNITO_USER_POOL_CLIENT_ID
    }
  }
} as any);

@Injectable({ providedIn: 'root' })
export class AuthService {
  private _user$ = new BehaviorSubject<{ sub: string; email: string } | undefined>(undefined);

  constructor() {
    // Initialen Auth-Status beim Laden ermitteln
    this.refreshUserState().catch(() => {});
  }

  get userChanges(): Observable<{ sub: string; email: string } | undefined> {
    return this._user$.asObservable();
  }

  async refreshUserState() {
    const u = await this.currentUser();
    this._user$.next(u);
  }

  async signIn(email: string, password: string) {
    const res = await signIn({ username: email, password });
    await this.refreshUserState();
    return res;
  }
  async signUp(email: string, password: string) {
    return await signUp({ username: email, password, options: { userAttributes: { email } } });
  }
  async confirm(email: string, code: string) {
    return await confirmSignUp({ username: email, confirmationCode: code });
  }
  async signOut() {
    const res = await signOut();
    await this.refreshUserState();
    return res;
  }
  async currentUser(): Promise<{ sub: string; email: string } | undefined> {
    try {
      const user = await getCurrentUser();
      const session = await fetchAuthSession();
      const sub = (session.tokens?.idToken?.payload as any)?.sub;
      return { sub, email: user.signInDetails?.loginId || '' };
    } catch {
      return undefined;
    }
  }
  async getIdToken(): Promise<string | undefined> {
    try {
      const session = await fetchAuthSession();
      return session.tokens?.idToken?.toString();
    } catch {
      return undefined;
    }
  }
  async isAdmin(): Promise<boolean> {
    try {
      const session = await fetchAuthSession();
      const profile = (session.tokens?.idToken?.payload as any)?.profile;
      return profile === 'admin';
    } catch {
      return false;
    }
  }
}
